import PerfectScrollbar from 'perfect-scrollbar';

let scrollBlocks = $('.ios-scroll');
export let perfectScrollbars = [];
for(let i = 0; i < scrollBlocks.length; i++) {
  perfectScrollbars.push(new PerfectScrollbar(scrollBlocks[i], {}));
}